export default "__VITE_ASSET__093d3c15__"